export const footerDetails = {
  title: "Moonpad",
  heading: "Contact Us",
  email: "info@dingbotnft.com",
  copywrite: "Copyright © 2021. All rights reserved.",
};
